import {UnknownObject} from '../types.ts';

/*
 * Back to front, the way the server orders a board: by ordinalPosition, with
 * the element id breaking a tie (two people adding at the same moment can
 * write the same position). Elements with no position go last.
 */
export const compareOrdinal = (
    ordinalPositionA: number | undefined,
    ordinalPositionB: number | undefined,
    idA: string | undefined,
    idB: string | undefined
) => {
    if (ordinalPositionA !== undefined && ordinalPositionB !== undefined) {
        const byPosition = Number(ordinalPositionA) - Number(ordinalPositionB);
        if (byPosition !== 0) {
            return byPosition;
        }
    } else if (ordinalPositionA !== undefined) {
        return -1;
    } else if (ordinalPositionB !== undefined) {
        return 1;
    }

    return (idA ?? '').localeCompare(idB ?? '');
};

export const elementDataSorter = (
    [idA, a]: [string, UnknownObject],
    [idB, b]: [string, UnknownObject]
) =>
    compareOrdinal(
        a.ordinalPosition as number | undefined,
        b.ordinalPosition as number | undefined,
        idA,
        idB
    );

export default elementDataSorter;
